<template>
    <div>
        <AppLoading v-if="isLoading" />
        <template v-else-if="error"> {{ error }} </template>
        <v-list v-else-if="paginas?.items">
            <v-list-item v-if="!paginas.items.length">
                <v-list-item-content class="text-center">
                    <v-list-item-title> Nenhum serviço registrado </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
    
            <v-list-item
                v-for="servico in paginas?.items"
                :key="servico._id"
                @click="mostrarServico(servico)"
            >
                <v-list-item-content>
                    <v-list-item-title class="text-wrap"> {{ servico.titulo }} </v-list-item-title>
                    <v-list-item-subtitle v-if="servico.descricao" class="text-wrap"> {{ servico.descricao }} </v-list-item-subtitle>
                </v-list-item-content>
                <ComponentAuthGuard :requires="[adminIrmaoGuard]" >
                    <v-list-item-action>
                        <v-btn icon :to="{ name: 'editar-servico', params: { id: servico._id }  }">
                            <v-icon small> mdi-pencil </v-icon>
                        </v-btn>
                    </v-list-item-action>
                    <v-list-item-action>
                        <DialogExcluirServico :servico="servico">
                            <template #activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon small> mdi-delete </v-icon>
                                </v-btn>
                            </template>
                        </DialogExcluirServico>
                    </v-list-item-action>
                </ComponentAuthGuard>
            </v-list-item>
            <ComponentAuthGuard :requires="[adminIrmaoGuard]" v-if="paginas.items.length < 2" >
                <v-list-item>
                    <v-btn
                        color="primary"
                        block
                        outlined
                        :to="{
                            name: 'novo-servico',
                            query: {
                                irmao: JSON.stringify({
                                    _id: prop.irmao._id,
                                    nomeCompleto: prop.irmao.nomeCompleto,
                                    loja: { _id: prop.irmao.loja._id, urlLogo: prop.irmao.loja.urlLogo },
                                    somar: { _id: prop.irmao.somar._id },
                                })
                            }
                        }"
                    >
                        <v-icon small left> mdi-plus </v-icon>
                        Adicionar serviço
                    </v-btn>
                </v-list-item>
            </ComponentAuthGuard>
        </v-list>
		<DialogDetalhesDoServico
			v-if="selecionado"
			v-model="selecionado"
			:servico="selecionado"
		/>
    </div>
</template>

<script setup lang="ts">
import ServicoService from '@/services/ServicoService';
import Irmao from '@/../common/types/Irmao'
import { useQuery } from '@tanstack/vue-query';
import { adminIrmaoGuard } from '@/shareds/sharedsIrmao';
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue';
import DialogExcluirServico from '@/components/servico/DialogExcluirServico.vue';
import DialogDetalhesDoServico from '@/components/servico/DialogDetalhesDoServico.vue';
import { ref } from 'vue';
import { Servico } from 'common/types/Servico';

const prop = defineProps<{ irmao: Irmao }>()

const mostraServico = ref(false)
const selecionado = ref<Servico>()

function mostrarServico(servico: Servico) {
	selecionado.value = servico
	mostraServico.value = true
}

const { data: paginas, error, isLoading } = useQuery({
    queryKey: ['servicos', prop.irmao._id],
    queryFn: () => ServicoService.findPage({
        irmao: prop.irmao._id,
    }),
})
</script>